const DepartmentComponent = {
    data() {
        return {
            loading: false,

            departmentId: 0,

            group: null,
            reasons: [],
            steps: [],
            services: [],
            specialists: [],

            swiper: null,

            baseUrl: window.appConfig?.baseUrl || '',
            plugImage: window.appConfig?.specialistsPlug || '/img/plug.jpg',
        };
    },

    methods: {

        async load() {

            if (!this.departmentId) return;

            this.loading = true;

            try {

                const response = await window.departmentService.getDepartment({
                    id: this.departmentId,

                    settings: {
                        services: { limit: 200, orderBy: 'title', orderDir: 'asc' },
                        specialists: { limit: 12, source: 'services', orderBy: 'estimation', orderDir: 'desc' },
                    }
                });

                if (response.status !== 200) {
                    console.error('[Department] bad response', response);
                    return;
                }

                const data = response.data || {};

                this.group = data.group || null;
                this.reasons = data.reasons || [];
                this.services = data.services || [];
                this.specialists = data.specialists || [];
                this.steps = data.steps || [];

                this.$nextTick(() => {
                    this.initSpecialistsSwiper();
                });

            } catch (e) {

                console.error('[Department] load failed', e);

            } finally {

                this.loading = false;

            }
        },

        getAvatarUrl(avatar) {
            const a = (avatar || '').trim();
            if (!a) return this.plugImage;

            if (a.startsWith('http://') || a.startsWith('https://')) return a;
            const base = (this.baseUrl || '').replace(/\/+$/, '');
            const path = a.startsWith('/') ? a : `/${a}`;

            return base ? `${base}${path}` : path;
        },

        formatNumber(n) {
            const num = Number(n) || 0;
            return String(num).padStart(2, '0');
        },

        formatPrice(price) {
            return window.globalState?.formatPrice
                ? window.globalState.formatPrice(price)
                : String(price || 0);
        },

        initSpecialistsSwiper() {

            const root = this.$el;
            const slider = root.querySelector('.specialistsSlider');
            const nextEl = root.querySelector('.slider__top-next');
            const prevEl = root.querySelector('.slider__top-prev');

            if (!slider) return;

            if (this.swiper) {
                this.swiper.update();
                return;
            }

            this.swiper = new Swiper(slider, {
                slidesPerView: 1.15,
                spaceBetween: 16,
                navigation: { nextEl, prevEl },
                breakpoints: {
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                },
            });
        },
    },

    mounted() {
        const id = Number(this.$el?.getAttribute('data-department-id') || 0);
        this.departmentId = id;
        this.load();
    },

    template: `
        <div v-if="group">

            <!-- HERO -->
            <section class="hero" data-aos="fade-up">
                <div class="container">
                    <div class="hero-wrapper">
                        <div class="col">
                            <div class="hero-info">
                                <h1 class="hero-title">{{ group.web_title || group.title }}</h1>

                                <div class="hero-text" v-if="group.web_description || group.description">
  <p v-for="(p, i) in String(group.web_description || group.description).split('\\n')" :key="i">
    {{ p }}
  </p>
</div>
                            </div>

                            <a :href="group.web_button_url || '#'"
                               class="btn">
                                {{ group.web_button_text || 'Записаться на приём' }}
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <rect width="9" height="2" fill="white" />
                                    <rect x="10" y="3" width="2" height="9" fill="white" />
                                </svg>
                            </a>
                        </div>

                        <div class="col">
                            <img :src="group.web_image_url || plugImage" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <!-- SERVICES -->
            <section class="services" data-aos="fade-up" v-if="services.length">
                <div class="container">
                    <h2 class="section-title">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_35_124)">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M8.71309 0.395996H11.0893V8.91085H8.71309V0.395996ZM0.198242 11.2871V8.91085H8.71309V11.2871H0.198242ZM11.0893 11.2871V8.91085H19.6042V11.2871H11.0893ZM8.71309 11.2871H11.0893V19.8019H8.71309V11.2871Z"
                                      fill="#3266DE" />
                            </g>
                            <defs>
                                <clipPath id="clip0_35_124">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        Услуги и цены
                    </h2>

                    <div class="services-wrapper">
                        <a v-for="(s, i) in services" :key="s.id" :href="s.url || '#'" class="services-item">
                            <p class="services-number">{{ formatNumber(i+1) }}</p>
                            <p class="services-title">{{ s.title }}</p>
                            <p class="services-price">{{ formatPrice(s.price) }} ₽</p>
                        </a>
                    </div>
                </div>
            </section>

            <!-- REASONS -->
            <section class="benefits benefits__departament" data-aos="fade-up" v-if="reasons.length">
                <div class="container">
                    <h2 class="section-title">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_35_124)">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M8.71309 0.395996H11.0893V8.91085H8.71309V0.395996ZM0.198242 11.2871V8.91085H8.71309V11.2871H0.198242ZM11.0893 11.2871V8.91085H19.6042V11.2871H11.0893ZM8.71309 11.2871H11.0893V19.8019H8.71309V11.2871Z"
                                      fill="#3266DE" />
                            </g>
                            <defs>
                                <clipPath id="clip0_35_124">
                                    <rect width="20" height="20" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                        Частые причины обращения
                    </h2>

                    <div class="benefits-wrapper__long">
                        <div class="benefits-item" v-for="(r, i) in reasons" :key="r.id">
                            <div class="col"><p class="benefits-bigtitle">{{ formatNumber(i+1) }}</p></div>
                            <div class="col"><p class="benefits-title">{{ r.title }}</p></div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- SPECIALISTS -->
            <section class="specialists" data-aos="fade-up" v-if="specialists.length">
                <div class="container">
                    <div class="swiper specialistsSlider">

                        <div class="slider__top">
                            <h2 class="section-title">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_35_124)">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M8.71309 0.395996H11.0893V8.91085H8.71309V0.395996ZM0.198242 11.2871V8.91085H8.71309V11.2871H0.198242ZM11.0893 11.2871V8.91085H19.6042V11.2871H11.0893ZM8.71309 11.2871H11.0893V19.8019H8.71309V11.2871Z"
                                              fill="#3266DE" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_35_124">
                                            <rect width="20" height="20" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                Наши врачи
                            </h2>

                            <div class="col">
                                <div class="slider__top-btns">
                                    <div class="slider__top-btn slider__top-prev">
                                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.17571 9.90294L2.00382 5.73105L0.731042 7.00383L4.90293 11.1757L6.17571 9.90294Z" fill="#3266DE" />
                                            <path d="M6.11926 1.59819L4.84648 0.325409L0.674591 4.4973L1.94737 5.77008L6.11926 1.59819Z" fill="#3266DE" />
                                        </svg>
                                    </div>
                                    <div class="slider__top-btn slider__top-next">
                                        <svg width="7" height="12" viewBox="0 0 7 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.674591 1.59819L4.84648 5.77008L6.11926 4.4973L1.94737 0.32541L0.674591 1.59819Z" fill="#3266DE" />
                                            <path d="M0.731042 9.90294L2.00382 11.1757L6.17571 7.00383L4.90293 5.73105L0.731042 9.90294Z" fill="#3266DE" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="sp in specialists" :key="sp.id">
                                <a :href="sp.url || '#'" class="specialists-slide">

<!--                                    <div class="specialists-slide__rating">-->
<!--                                        {{ sp.rating }}-->
<!--                                    </div>-->

                                    <div class="specialists-slide__img">
                                        <img :src="getAvatarUrl(sp.avatar)" alt="">
                                    </div>

                                    <p class="specialists-slide__name">
                                        {{ sp.name }}
                                    </p>

                                    <ul class="specialists-slide__positions">
                                        <li v-for="p in (sp.professions || [])" :key="p">{{ p }}</li>
                                    </ul>

                                    <div class="specialists-slide__box">
                                        <p>{{ sp.post }}</p>

                                        <object data="" type="">
                                            <a :href="sp.recordUrl || sp.url || '#'" class="btn">
                                                Записаться на приём
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="9" height="2" fill="white" />
                                                    <rect x="10" y="3" width="2" height="9" fill="white" />
                                                </svg>
                                            </a>
                                        </object>
                                    </div>

                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <!-- STEPS: пока статика (потом тоже вынесем в настройки) -->
            <section class="steps" data-aos="fade-up" v-if="steps.length">
  <div class="container">
    <h2 class="section-title">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_35_124)">
          <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.71309 0.395996H11.0893V8.91085H8.71309V0.395996ZM0.198242 11.2871V8.91085H8.71309V11.2871H0.198242ZM11.0893 11.2871V8.91085H19.6042V11.2871H11.0893ZM8.71309 11.2871H11.0893V19.8019H8.71309V11.2871Z"
                fill="#3266DE" />
        </g>
        <defs>
          <clipPath id="clip0_35_124">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
      Почему онлайн помощь стала востребована?
    </h2>

    <div class="steps-wrapper">
      <div class="step" v-for="s in steps" :key="s.id">
        <img v-if="s.image_url" :src="s.image_url" alt="">
        <h3>{{ s.title }}</h3>
        <p v-if="s.text">{{ s.text }}</p>
      </div>
    </div>
  </div>
</section>

        </div>
    `
};

window.DepartmentComponent = DepartmentComponent;